import React, { useEffect, useState, useRef } from "react";
import Container from "react-bootstrap/Container";
import "../assets/css/modal.css";
import ModalConferma from "../components/Generics/Modal/ModalConferma";
import Col from "react-bootstrap/Col";
import Cookies from "js-cookie";
import Table from "react-bootstrap/Table";
// import Axios from "axios/index";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import axios, { Axios } from "axios";
import {
  Autocomplete,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  MenuItem,
  Modal,
  Paper,
  Select,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import ModalSuccess from "../components/Generics/Modal/ModalSuccess";
import ModalReset from "../components/Generics/Modal/ModalReset";
import ModalHelper from "../components/Generics/Modal/ModalHelper";
import mobilePrefixes from "../utils/mobile-prefixes.json";

const Paperwork = () => {
  // let access_token = Cookies.get("access_token");
  const access_token = localStorage.getItem("token");
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [paperwork, setPaperwork] = useState([]);
  const [signers, setSigners] = useState([]);
  const [readers, setReaders] = useState([]);
  const [departmentName, setDepartmentName] = useState("");
  const [filesNotSigned, setFilesNotSigned] = useState([]);
  const [filesSigned, setFilesSigned] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [fileDownload, setFileDownload] = useState("");
  const [paperworkId, setPaperworkId] = useState("");
  const [errors, setErrors] = useState([]);

  const [showRestart, setShowRestart] = useState(false);
  const [showRestartSuccess, setShowRestartSuccess] = useState(false);

  const [showReminder, setShowReminder] = useState(false);
  const [numeroSignReminder, setNumeroSignReminder] = useState(false);

  const [showUpdate, setShowUpdate] = useState(false);

  const [responseEp, setResponseEp] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [statusPaperwork, setStatusPaperwork] = useState(false);
  const [statusTitleTableCol, setStatusTitleTableCol] = useState("");

  //For change data signer
  const [showChangeFirmatario, setShowChangeFirmatario] = useState(false);
  const [changeSigner, setChangeSigner] = useState([]);
  const [messageEmailValidation, setMessageEmailValidation] = useState([]);
  const [disableButtonUpdateDataSigner, setDisableButtonUpdateDataSigner] =
    useState(false);
  const [prefixSigner, setPrefixSigner] = useState("+39");
  const [phoneWithoutPrefix, setPhoneWithoutPrefix] = useState("");

  const [colorMessage, setColorMessage] = useState("");
  const [isDeleted, setIsDeleted] = useState(false);
  const [emailCheckValidation, setEmailCheckValidation] = useState("");
  const arrChangeSigner = [];
  const form = useRef(null);

  const [showUpdateSuccess, setShowUpdateSuccess] = useState(false);
  const [showReminderSuccess, setShowReminderSuccess] = useState(false);

  // overlay e modal alert visualizzazione mobile ruota display

  const [showRotateModal, setShowRotateModal] = useState(() => {
    const hasSeenModal = localStorage.getItem("rotateModalDismissed");
    return window.innerWidth < 600 && !hasSeenModal;
  });

  const handleCloseRotateModal = () => {
    localStorage.setItem("rotateModalDismissed", "true");
    setShowRotateModal(false);
  };

  useEffect(() => {
    const handleResize = () => {
      const hasSeenModal = localStorage.getItem("rotateModalDismissed");
      if (window.innerWidth < 600 && !hasSeenModal) {
        setShowRotateModal(true);
      } else {
        setShowRotateModal(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleGoBackUpdateSuccess = () => {
    setShowUpdateSuccess(false);
    window.location.reload(false);
  };

  const handleGoBackReminderSuccess = () => {
    setShowReminderSuccess(false);
    // window.location.reload(false);
  };

  const fData = new FormData();

  const location = useLocation();

  const downloadFileHandle = (file) => () => {
    //e.preventDefault();

    const config = {
      headers: {
        Authorization: "Bearer " + access_token,
        "Content-Type": "multipart/form-data",
      },
    };

    fData.append("file_name", file);
    fData.append("paperwork_id", paperworkId);

    /*Axios.defaults.headers = {
            'Content-Type': 'multipart/form-data',
        };*/

    let endpoint = process.env.REACT_APP_ENPOINT + "download-file-to-sign";
    axios({
      method: "post",
      responseType: "blob", // importante, altrimenti non funziona, pdf mal formattato
      url: endpoint,
      data: fData,
      headers: {
        Authorization: "Bearer " + access_token,
      },
      transformRequest: (data, error) => {
        return fData;
      },
    })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "file.pdf"); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .catch((e) => {
        console.error("Failure", e);
      });
  };

  const downloadFileSignedHandle = (file) => () => {
    //e.preventDefault();

    const config = {
      headers: {
        Authorization: "Bearer " + access_token,
        "Content-Type": "multipart/form-data",
      },
    };

    fData.append("file_name", file);
    fData.append("paperwork_id", paperworkId);

    /*Axios.defaults.headers = {
            'Content-Type': 'multipart/form-data',
        };*/

    let endpoint = process.env.REACT_APP_ENPOINT + "download-file-signed";
    axios({
      method: "post",
      responseType: "blob", // importante, altrimenti non funziona, pdf mal formattato
      url: endpoint,
      data: fData,
      headers: {
        Authorization: "Bearer " + access_token,
      },
      transformRequest: (data, error) => {
        return fData;
      },
    })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "document-signed.pdf"); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .catch((e) => {
        console.error("Failure", e);
      });
  };

  const getListCompleted = async () => {
    if (!responseEp) {
      let endpoint =
        process.env.REACT_APP_ENPOINT + location.pathname.substring(1);
      //fetch(endpoint).then(response => response.json()).then(data => console.log(data));
      const response = await fetch(endpoint, {
        method: "PUT",
        //body: JSON.stringify(data),
        headers: {
          Authorization: "Bearer " + access_token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      const result = await response.json();
      setData(result);
      //setResponseEp(true);
      setPaperwork(result.paperwork);
      setSigners(result.signers);
      setReaders(result.readers);
      setPaperworkId(result.paperwork_id);
      setFilesNotSigned(result.files);
      setFilesSigned(result.files_s);
      setDepartmentName(result.department_name);

      if (result.paperwork[0].completed === 1) {
        setStatusTitleTableCol("Data completamento");
        setStatusPaperwork(true);
      }
      if (result.paperwork[0].completed === 0) {
        setStatusTitleTableCol("Data creazione");
        setStatusPaperwork(false);
      }
      return result;
    }
  };

  const handleGoBackChangeFirmatario = () => {
    //setMessageEmailValidation("");
    //setColorMessage('black-message');
    setShowChangeFirmatario(false);
    console.log("okkk");
  };

  const handlePrefixChange = (event) => {
    setPrefixSigner(event.target.value);
  };

  const handleChangeData = (change) => {
    // Estrai il prefisso dal numero di telefono
    let detectedPrefix = "+39";
    let phoneNumber = change.phone_number ? change.phone_number.trim() : "";

    // Cerca di trovare un prefisso valido nel numero
    if (phoneNumber) {
      const matchedCountry = mobilePrefixes.find(country =>
        phoneNumber.startsWith(country.dial_code)
      );

      if (matchedCountry) {
        detectedPrefix = matchedCountry.dial_code;
        phoneNumber = phoneNumber.substring(matchedCountry.dial_code.length).trim();
      }
    }

    const arrChangeSigner = {
      id_signer: change.id,
      firstname: change.name ? change.name.trim() : "",
      lastname: change.surname ? change.surname.trim() : "",
      email: change.email ? change.email.trim() : "",
      phone_number: phoneNumber,
    };

    setChangeSigner(arrChangeSigner);
    setPrefixSigner(detectedPrefix);
    setPhoneWithoutPrefix(phoneNumber);
    setShowChangeFirmatario(true);
  };

  const downloadAuditTrail = (signer) => () => {
    //download-audit-trail-to-signer
    const fData = new FormData();
    let data = {
      signer_to_update: {
        id_signer: signer.id,
        firstname: null,
        lastname: null,
        email: null,
        phone_number: null
      },
      paperwork_id: paperworkId
    }

    for (var key in signer) {
      if (key === "name") {
        if (dataUpdate.firstname != null) {
          data.signer_to_update.firstname = signer.firstname.trim()
        } else {
          data.signer_to_update.firstname = signer[key]
        }
      }

      if (key === "surname") {
        if (dataUpdate.lastname != null) {
          data.signer_to_update.lastname = signer.lastname.trim();
        } else {
          data.signer_to_update.lastname = signer[key];
        }
      }

      if (key === "email") {
        if (dataUpdate.email != null) {
          data.signer_to_update.email = signer.email.trim();
        } else {
          data.signer_to_update.email = signer[key];
        }
      }

      if (key === "phone_number") {
        if (dataUpdate.phone_number != null) {
          data.signer_to_update.phone_number = signer.phone_number.trim();
        } else {
          data.signer_to_update.phone_number = signer[key];
        }
      }
    }

    //fData.append('Signer_to_update[]', {key: dataSigner[key]});

    const config = {
      headers: {
        Authorization: "Bearer " + access_token,
        "Content-Type": "multipart/form-data",
      },
    };

    let obj = { json_data: JSON.stringify(data) };
    let endpoint =
      process.env.REACT_APP_ENPOINT + "download-audit-trail-to-signer";
    axios({
      method: "post",
      responseType: "blob", // importante, altrimenti non funziona, pdf mal formattato
      url: endpoint,
      data: data,
      headers: {
        Authorization: "Bearer " + access_token,
      }
    })
      .then((res) => {
        console.log(res.data)
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "audit-trail.pdf"); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .catch((e) => {
        console.error("Failure", e);
      });
  };

  const handleChangeEmail = (input) => {
    setEmailCheckValidation(input.value);

    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    //const pattern = /^[-a-zA-Z0-9-()]+(\s+[-a-zA-Z0-9-()]+)*$/i;
    const pattern = /^\s+|\s+$/g;

    input.value.replace(pattern, "");

    if (regex.test(input.value) === true) {
      setMessageEmailValidation("Valid email format.");
      setColorMessage("black-message");
    }
    //setPaperwork(input.value);
  };

  const [dataUpdate, setDataUpdate] = useState({
    id_signer: null,
    firstname: null,
    lastname: null,
    email: null,
    phone_number: null,
  });

  const subimtDataChange = (dataSigner) => () => {
    setShowUpdate(false);
    const newErrors = [];
    const isElectronic = paperwork[0]?.signature_level === "electronic";
    const requiredFields = isElectronic
      ? ["firstname", "lastname", "email"]
      : ["firstname", "lastname", "email", "phone_number"];

    requiredFields.forEach((field) => {
      const value = dataUpdate[field]?.trim() ?? dataSigner[field]?.trim();
      if (!value) {
        newErrors.push(field);
      }
    });
    console.log(newErrors)
    if (newErrors.length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors([]);
    setIsLoading(true);
    setShowChangeFirmatario(false);
    setDisableButtonUpdateDataSigner(true);

    const fData = new FormData();

    const appendField = (key) => {
      let value = dataUpdate[key]?.trim() ?? dataSigner[key];
      // Combina prefisso + numero per il campo phone_number
      if (key === "phone_number") {
        const phoneNum = dataUpdate[key]?.trim() ?? dataSigner[key];
        value = `${prefixSigner}${phoneNum}`;
      }
      fData.append(`signer_to_update[${key}]`, value);
    };

    const fieldsToAppend = isElectronic
      ? ["id_signer", "firstname", "lastname", "email"]
      : ["id_signer", ...requiredFields];

    fieldsToAppend.forEach((key) => {
      appendField(key);
    });

    fData.append("paperwork_id", paperworkId);

    const endpoint = process.env.REACT_APP_ENPOINT + "update-signer";

    axios({
      method: "put",
      url: endpoint,
      data: fData,
      headers: {
        "content-type": "application/json",
        Authorization: "Bearer " + access_token,
      },
    })
      .then((res) => {
        if (res.data?.error) {
          alert(res.data.error);
          setDisableButtonUpdateDataSigner(false);
        } else if (res.data?.message_error) {
          alert(res.data.message_error);
          setDisableButtonUpdateDataSigner(false);
        } else {
          setIsLoading(false);
          setShowChangeFirmatario(false);
          setDisableButtonUpdateDataSigner(false);
          window.location.reload(false);
        }
      })
      .catch((e) => {
        console.error("Failure", e);
        setDisableButtonUpdateDataSigner(false);
      });
  };

  const handleOpenShowUpdate = (changeSigner) => {
    const newErrors = [];
    const isElectronic = paperwork[0]?.signature_level === "electronic";
    const requiredFields = isElectronic
      ? ["firstname", "lastname", "email"]
      : ["firstname", "lastname", "email", "phone_number"];

    requiredFields.forEach((field) => {
      const value = dataUpdate[field]?.trim() ?? changeSigner[field]?.trim();
      if (!value) {
        newErrors.push(field);
      }
    });

    if (newErrors.length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors([]);
  };

  const handleCloseShowUpdate = () => {
    setShowUpdate(false);
  };

  const handleOpenShowReminder = (numero) => {
    setShowReminder(true);
    setNumeroSignReminder(numero);
    console.log(numeroSignReminder);
  };

  const handleCloseShowReminder = () => {
    setShowReminder(false);
  };

  const subimtReminder = (dataSigner) => () => {
    //data.preventDefault();
    const fData = new FormData();
    setIsLoading(true);

    for (var key in dataSigner) {
      if (key === "id") {
        if (dataUpdate.firstname != null) {
          fData.append("signer_to_update[" + key + "]", dataUpdate.id.trim());
          fData.append("paperwork_id", paperworkId);
        } else {
          fData.append("signer_to_update[" + key + "]", dataSigner[key]);
          fData.append("paperwork_id", paperworkId);
        }
      }

      if (key === "firstname") {
        if (dataUpdate.firstname != null) {
          fData.append(
            "signer_to_update[" + key + "]",
            dataUpdate.firstname.trim()
          );
          fData.append("paperwork_id", paperworkId);
        } else {
          fData.append("signer_to_update[" + key + "]", dataSigner[key]);
          fData.append("paperwork_id", paperworkId);
        }
      }

      if (key === "lastname") {
        if (dataUpdate.lastname != null) {
          fData.append(
            "signer_to_update[" + key + "]",
            dataUpdate.lastname.trim()
          );
          fData.append("paperwork_id", paperworkId);
        } else {
          fData.append("signer_to_update[" + key + "]", dataSigner[key]);
          fData.append("paperwork_id", paperworkId);
        }
      }

      if (key === "email") {
        if (dataUpdate.email != null) {
          fData.append(
            "signer_to_update[" + key + "]",
            dataUpdate.email.trim()
          );
          fData.append("paperwork_id", paperworkId);
        } else {
          fData.append("signer_to_update[" + key + "]", dataSigner[key]);
          fData.append("paperwork_id", paperworkId);
        }
      }

      if (key === "phone_number") {
        if (dataUpdate.phone_number != null) {
          fData.append(
            "signer_to_update[" + key + "]",
            dataUpdate.phone_number.trim()
          );
          fData.append("paperwork_id", paperworkId);
        } else {
          fData.append("signer_to_update[" + key + "]", dataSigner[key]);
          fData.append("paperwork_id", paperworkId);
        }
      }
    }

    //fData.append('Signer_to_update[]', {key: dataSigner[key]});

    const config = {
      headers: {
        Authorization: "Bearer " + access_token,
        "Content-Type": "multipart/form-data",
      },
    };

    axios.defaults.headers = {
      "Content-Type": "multipart/form-data",
    };

    let obj = { json_data: JSON.stringify(data) };
    let endpoint = process.env.REACT_APP_ENPOINT + "send-reminder-to-signer";
    axios({
      method: "post",
      url: endpoint,
      data: dataUpdate,
      headers: {
        "content-type": "application/json",
        Authorization: "Bearer " + access_token,
      },
      transformRequest: (data, error) => {
        return fData;
      },
    })
      .then((res) => {
        if (res.data.hasOwnProperty("error")) {
          alert(res.data.error);
        } else {
          if (typeof res.data.message_error != "undefined") {
            alert(res.data.message_error);
          } else {
            setIsLoading(false);
            setShowReminder(false);
            setShowReminderSuccess(true);
            // alert("A reminder has just been sent.");
          }
          //window.location.href = '/signing-pending';
        }
      })
      .catch((e) => {
        console.error("Failure", e);
      });
  };

  useEffect(() => {
    getListCompleted();

    /*data.forEach( item => {
            console.log(item.completed);
        });*/
  }, []);

  const signersList = signers.map((numero, index) => (
    <>
      <TableRow key={index} style={{ height: "50px" }}>
        <TableCell
          sx={{
            padding: "8px",
            whiteSpace: { xs: "nowrap", sm: "normal" },
          }}
          className="color-blue-dark"
        >
          <Typography className="text-table">{numero.id}</Typography>
        </TableCell>
        <TableCell
          sx={{
            padding: "8px",
            whiteSpace: { xs: "nowrap", sm: "normal" },
          }}
          className="color-blue-dark"
        >
          <Typography className="text-table">
            {numero.name} {numero.surname}
          </Typography>
        </TableCell>
        <TableCell
          className="color-blue-dark"
          sx={{
            padding: "8px",
            whiteSpace: { xs: "nowrap", sm: "normal" },
          }}
        >
          <Typography className="text-table">{numero.email}</Typography>
        </TableCell>
        {paperwork[0]?.signature_level !== "electronic" && (
          <TableCell
            sx={{
              padding: "8px",
              whiteSpace: { xs: "nowrap", sm: "normal" },
            }}
            className="color-blue-dark"
          >
            <Typography className="text-table">{numero.phone_number}</Typography>
          </TableCell>
        )}

        <TableCell
          sx={{
            padding: "8px",
            whiteSpace: { xs: "nowrap", sm: "normal" },
          }}
          className="color-blue-dark"
        >
          <Typography className="text-table">
            {numero.signed ? "Completato" : "In corso"}
          </Typography>
        </TableCell>

        <TableCell
          className="color-blue-dark"
          style={{
            display: "flex",
            padding: "8px",
            height: "53px",
            alignItems: "center",
          }}
        >
          {paperwork.map((paperwork, index) => {
            // Controllo unificato delle azioni disponibili
            if (paperwork.status === "DELETED" || paperwork.id < 138) {
              return (
                <Typography key={index} className="color-blue-dark">
                  Non consentito
                </Typography>
              );
            }

            if (paperwork.status === "COMPLETED") {
              return numero.signed ? (
                <div
                  key={index}
                  onClick={downloadAuditTrail(numero)}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "20px",
                    height: "20px"
                  }}
                  className="icon-document"
                />
              ) : (
                <span
                  key={index}
                  onClick={handleChangeData(numero)}
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                  className="color-purple"
                >
                  Modifica
                </span>
              );
            }

            if (paperwork.status === "PENDING") {
              if (numero.signed) {
                return (
                  <Typography key={index} className="color-blue-dark">
                    -
                  </Typography>
                );
              }

              return (
                <div key={index} style={{ display: "flex", gap: "30px" }}>
                  <Button
                    variant="outlined"
                    className="button-bg-empty-small"
                    onClick={() => handleChangeData(numero)}
                    sx={{ marginBottom: 0 }}
                  >
                    <Typography
                      className="color-blue-dark"
                      style={{
                        textTransform: "initial",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >
                      Modifica
                    </Typography>
                  </Button>

                  <Button
                    className="button-bg-purple-small"
                    onClick={() => handleOpenShowReminder(numero)}
                    sx={{ marginBottom: 0, border: "none" }}
                  >
                    <Typography
                      className="color-light"
                      style={{
                        textTransform: "initial",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >
                      Promemoria
                    </Typography>
                  </Button>
                </div>
              );
            }

            return null;
          })}
        </TableCell>
      </TableRow>
    </>
  ));

  const readersList = readers.map((numero, index) => (
    <>
      <TableRow key={index} style={{ height: "50px" }}>
        <TableCell
          sx={{
            fontSize: "0.9rem",
            padding: "8px",
            whiteSpace: { xs: "nowrap", sm: "normal" },
          }}
          className="color-blue-dark"
        >
          <Typography className="text-table">{numero.id}</Typography>
        </TableCell>
        <TableCell
          sx={{
            padding: "8px",
            whiteSpace: { xs: "nowrap", sm: "normal" },
          }}
          className="color-blue-dark"
        >
          <Typography className="text-table">
            {numero.name} {numero.surname}
          </Typography>
        </TableCell>
        <TableCell
          sx={{
            padding: "8px",
            whiteSpace: { xs: "nowrap", sm: "normal" },
          }}
          className="color-blue-dark"
        >
          <Typography className="text-table">{numero.email}</Typography>
        </TableCell>
        {/* <TableCell sx={{ padding: "8px" }} className="color-blue-dark">
          <Typography className="text-table">{numero.phone_number}</Typography>
        </TableCell> */}

        <TableCell
          sx={{
            padding: "8px",
            whiteSpace: { xs: "nowrap", sm: "normal" },
          }}
          className="color-blue-dark"
        >
          <Typography className="text-table">Notificato</Typography>
        </TableCell>
      </TableRow>
    </>
  ));

  const filesNotSignedList = filesNotSigned.map((numero, index) => (
    <>
      <TableRow key={index} style={{ height: "50px" }}>
        <TableCell
          sx={{
            padding: "8px",
            whiteSpace: { xs: "nowrap", sm: "normal" },
          }}
          className="color-blue-dark"
        >
          <Typography className="text-table">{numero.name}</Typography>
        </TableCell>
        <TableCell
          sx={{
            padding: "8px",
            whiteSpace: { xs: "nowrap", sm: "normal" },
          }}
        >
          <div
            data-name-file={numero.name}
            className="icon-document"
            onClick={downloadFileHandle(numero.name)}
            style={{ cursor: "pointer" }}
          />
        </TableCell>

        <TableCell
          sx={{
            padding: "8px",
            whiteSpace: { xs: "nowrap", sm: "normal" },
          }}
          className="color-blue-dark"
        >
          <Typography className="text-table">Parziale</Typography>
        </TableCell>
      </TableRow>
    </>
  ));

  const filesSignedList = filesSigned.map((numero, index) => (
    <>
      <TableRow key={index} style={{ height: "50px" }}>
        <TableCell
          sx={{
            padding: "8px",
            whiteSpace: { xs: "nowrap", sm: "normal" },
          }}
          className="color-blue-dark"
        >
          <Typography className="text-table">{numero.name}</Typography>
        </TableCell>
        <TableCell
          sx={{
            padding: "8px",
            whiteSpace: { xs: "nowrap", sm: "normal" },
          }}
        >
          <div
            data-name-file={numero.name}
            onClick={downloadFileSignedHandle(numero.name)}
            className="icon-document"
            style={{ cursor: "pointer" }}
          />
        </TableCell>
        <TableCell
          sx={{
            padding: "8px",
            whiteSpace: { xs: "nowrap", sm: "normal" },
          }}
          className="color-blue-dark"
        >
          <Typography className="text-table">Firmato</Typography>
        </TableCell>
      </TableRow>
    </>
  ));

  const handleShowModalRestart = () => {
    setShowRestart(true);
  };

  const handleGoBackRestart = () => {
    setShowRestart(false);
  };

  const handleGoBackRestartSuccess = () => {
    setShowRestartSuccess(false);
    window.location.assign("/signing-pending");
  };

  const handleRestart = (input) => () => {
    setIsLoading(true);
    setShowRestart(false);
    const fData = new FormData();
    fData.append("paperwork_id", input);

    const endpoint = process.env.REACT_APP_ENPOINT + "restart-signing";

    axios
      .post(endpoint, fData, {
        headers: {
          Authorization: "Bearer " + access_token,
        },
      })
      .then((res) => {
        if (res.data?.error) {
          alert(res.data.error);
          setIsLoading(false);
        } else {
          setShowRestartSuccess(true);
          // setTimeout(function () {
          //   window.location.reload(false);
          // }, 5000);
          setIsLoading(false);
        }
      })
      .catch((e) => {
        console.error("Failure", e);
      });
  };

  if (statusPaperwork) {
    const lista = paperwork.map((numero, index) => {
      const date = new Date(numero.created_at);
      const timestamp = date.getTime();

      const date2 = new Date(timestamp);
      const dateLocale = date2.toLocaleString("it-IT");

      return (
        <>
          <TableRow key={index} style={{ height: "50px" }}>
            <TableCell
              sx={{
                padding: "8px",
                whiteSpace: { xs: "nowrap", sm: "normal" },
              }}
              className="color-blue-dark"
            >
              <Typography className="text-table">{numero.id}</Typography>
            </TableCell>
            <TableCell
              className="color-blue-dark"
              sx={{
                padding: "8px",
                whiteSpace: { xs: "nowrap", sm: "normal" },
              }}
            >
              <Typography className="text-table">
                {numero.paperwork_name}
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                padding: "8px",
                whiteSpace: { xs: "nowrap", sm: "normal" },
              }}
              className="color-blue-dark"
            >
              <Typography className="text-table">{dateLocale}</Typography>
            </TableCell>
            <TableCell
              sx={{
                padding: "8px",
                whiteSpace: { xs: "nowrap", sm: "normal" },
              }}
              className="color-blue-dark"
            >
              <Typography className="text-table">{departmentName}</Typography>
            </TableCell>
            <TableCell
              sx={{
                padding: "8px",
                whiteSpace: { xs: "nowrap", sm: "normal" },
              }}
              className="color-blue-dark"
            >
              <Typography className="text-table">
                {numero.signature_level === "advanced" ? "Firma Elettronica Rafforzata" : numero.signature_level === "electronic" ? "Firma Elettronica Semplice" : "-"}
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                padding: "8px",
                width: "150px",
                textAlign: "start",
                whiteSpace: { xs: "nowrap", sm: "normal" },
              }}
              className="color-blue-dark"
            >
              <Typography className="text-table">
                {numero.status === "DELETED" ? "Eliminato" : "Completato"}
              </Typography>
            </TableCell>
          </TableRow>
        </>
      );
    });

    return (
      <>
        <div style={{ marginTop: "150px", marginBottom: "50px" }}>
          <Grid container style={{ display: "flex", justifyContent: "center" }}>
            {/* Operation details */}
            <Grid item xs={11} md={10}>
              <Typography
                className="color-blue-dark"
                style={{
                  fontSize: "22px",
                  fontWeight: 600,
                  marginBottom: "30px",
                }}
              >
                Dettagli signing
              </Typography>

              <TableContainer
                component={Paper}
                sx={{ maxWidth: "100%", boxShadow: "none" }}
              >
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          ID
                        </Typography>
                      </TableCell>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          {" "}
                          Nome operazione
                        </Typography>
                      </TableCell>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          {" "}
                          Data creazione
                        </Typography>
                      </TableCell>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          {" "}
                          Team
                        </Typography>
                      </TableCell>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          {" "}
                          Livello firma
                        </Typography>
                      </TableCell>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          {" "}
                          Stato
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>{lista}</TableBody>
                </Table>
              </TableContainer>
            </Grid>

            {/* Signers */}
            <Grid item xs={11} md={10} style={{ marginTop: "30px" }}>
              <Typography
                className="color-blue-dark"
                style={{
                  fontSize: "22px",
                  fontWeight: 600,
                  marginBottom: "30px",
                }}
              >
                Firmatari
              </Typography>

              <TableContainer
                component={Paper}
                sx={{ maxWidth: "100%", boxShadow: "none" }}
              >
                <Table sx={{ minWidth: 350 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          ID
                        </Typography>
                      </TableCell>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          Nome e Cognome
                        </Typography>
                      </TableCell>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          Email
                        </Typography>
                      </TableCell>
                      {paperwork[0]?.signature_level !== "electronic" && (
                        <TableCell
                          className="color-blue-dark"
                          sx={{
                            padding: "8px",
                            whiteSpace: { xs: "nowrap", sm: "normal" },
                          }}
                        >
                          <Typography className="title-column-table text-bold">
                            Numero di telefono
                          </Typography>
                        </TableCell>
                      )}
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          Stato
                        </Typography>
                      </TableCell>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          Certificato
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>{signersList}</TableBody>
                </Table>
              </TableContainer>
            </Grid>

            {readers.length > 0 && (
              <>
                {/* Readers */}
                <Grid item xs={11} md={10} style={{ marginTop: "30px" }}>
                  <Typography
                    className="color-blue-dark"
                    style={{
                      fontSize: "22px",
                      fontWeight: 600,
                      marginBottom: "30px",
                    }}
                  >
                    Lettori
                  </Typography>

                  <TableContainer
                    component={Paper}
                    sx={{ maxWidth: "100%", boxShadow: "none" }}
                  >
                    <Table
                      sx={{ minWidth: 650, fontSize: "0.8rem" }}
                      aria-label="simple table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell
                            className="color-blue-dark"
                            sx={{
                              padding: "8px",
                              whiteSpace: { xs: "nowrap", sm: "normal" },
                            }}
                          >
                            <Typography className="title-column-table">
                              ID
                            </Typography>
                          </TableCell>
                          <TableCell
                            className="color-blue-dark"
                            sx={{
                              padding: "8px",
                              whiteSpace: { xs: "nowrap", sm: "normal" },
                            }}
                          >
                            <Typography className="title-column-table">
                              Nome e Cognome
                            </Typography>
                          </TableCell>
                          <TableCell
                            className="color-blue-dark"
                            sx={{
                              padding: "8px",
                              whiteSpace: { xs: "nowrap", sm: "normal" },
                            }}
                          >
                            <Typography className="title-column-table">
                              Email
                            </Typography>
                          </TableCell>
                          {/* <TableCell
                            className="color-blue-dark"
                            sx={{ padding: "8px" }}
                          >
                            <Typography className="title-column-table">
                              Numero di telefono
                            </Typography>
                          </TableCell> */}
                          <TableCell
                            className="color-blue-dark"
                            sx={{
                              padding: "8px",
                              whiteSpace: { xs: "nowrap", sm: "normal" },
                            }}
                          >
                            <Typography className="title-column-table">
                              Stato
                            </Typography>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>{readersList}</TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </>
            )}

            {/* Files signed */}
            <Grid item xs={11} md={10} style={{ marginTop: "30px" }}>
              <Typography
                className="color-blue-dark"
                style={{
                  fontSize: "22px",
                  fontWeight: 600,
                  marginBottom: "30px",
                }}
              >
                Documenti
              </Typography>

              {filesSigned.length === 0 ? (
                <Typography
                  className="color-blue-dark"
                  sx={{
                    fontSize: { xs: "16px", md: "18px" },
                    fontWeight: 500,
                    marginTop: "20px",
                    marginBottom: "20px",
                  }}
                >
                  Nessun file disponibile.
                </Typography>
              ) : (
                <TableContainer
                  component={Paper}
                  sx={{ maxWidth: "100%", boxShadow: "none" }}
                >
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          className="color-blue-dark"
                          sx={{
                            padding: "8px",
                            whiteSpace: { xs: "nowrap", sm: "normal" },
                          }}
                        >
                          <Typography className="title-column-table text-bold">
                            Titolo
                          </Typography>
                        </TableCell>
                        <TableCell
                          className="color-blue-dark"
                          sx={{
                            padding: "8px",
                            whiteSpace: { xs: "nowrap", sm: "normal" },
                          }}
                        >
                          <Typography className="title-column-table text-bold">
                            File
                          </Typography>
                        </TableCell>
                        <TableCell
                          className="color-blue-dark"
                          sx={{
                            padding: "8px",
                            whiteSpace: { xs: "nowrap", sm: "normal" },
                          }}
                        >
                          <Typography className="title-column-table text-bold">
                            Stato
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>{filesSignedList}</TableBody>
                  </Table>
                </TableContainer>
              )}
            </Grid>
          </Grid>

          <Modal
            open={showChangeFirmatario}
            onClose={handleGoBackChangeFirmatario}
            aria-labelledby="change-signer-title"
            aria-describedby="change-signer-description"
          >
            <Grid
              container
              item
              xs={11}
              md={5}
              sx={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "#fff",
                maxHeight: "90vh",
                overflowY: "auto",
                boxShadow: 24,
              }}
            >
              {/* Header */}
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid #c6c6c6",
                  paddingBottom: 2,
                  marginBottom: 2,
                }}
              >
                <div style={{ display: "flex" }}>
                  <div className="icon-modal-edit" />
                  <Typography
                    id="change-signer-title"
                    variant="h6"
                    className="color-blue-dark"
                  >
                    Modifica dati firmatario
                  </Typography>
                </div>
                <div
                  onClick={handleGoBackChangeFirmatario}
                  className="icon-modal-close"
                />
              </Grid>

              {/* Body */}
              <Typography variant="body2" sx={{ mb: 2 }}>
                In caso di operazioni con più di 20 firmatari, contattare il
                team tecnico prima di avviare la firma.
              </Typography>

              <Grid item xs={12} sx={{ mb: 2 }}>
                <Typography
                  style={{ fontSize: "14px" }}
                  className="color-dark-blue"
                >
                  Nome
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  name="signer_firstname"
                  defaultValue={changeSigner.firstname}
                  onChange={(e) =>
                    setDataUpdate({
                      ...dataUpdate,
                      firstname: e.target.value,
                    })
                  }
                  placeholder="First name"
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} sx={{ mb: 2 }}>
                <Typography
                  style={{ fontSize: "14px" }}
                  className="color-dark-blue"
                >
                  Cognome
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  name="signer_lastname"
                  defaultValue={changeSigner.lastname}
                  onChange={(e) =>
                    setDataUpdate({
                      ...dataUpdate,
                      lastname: e.target.value,
                    })
                  }
                  placeholder="Last name"
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} sx={{ mb: 2 }}>
                <Typography
                  style={{ fontSize: "14px" }}
                  className="color-dark-blue"
                >
                  Email
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="email"
                  name="signer_email"
                  defaultValue={changeSigner.email}
                  onChange={(e) =>
                    setDataUpdate({
                      ...dataUpdate,
                      email: e.target.value,
                    })
                  }
                  placeholder="name@example.com"
                  variant="outlined"
                />
                <Typography className={colorMessage}>
                  {messageEmailValidation}
                </Typography>
              </Grid>

              {paperwork[0]?.signature_level !== "electronic" && (
                <Grid item xs={12} sx={{ mb: 2 }}>
                  <Typography
                    style={{ fontSize: "14px" }}
                    className="color-dark-blue"
                  >
                    Numero di telefono
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6} sm={3}>
                      <Autocomplete
                        options={mobilePrefixes}
                        value={mobilePrefixes.find(c => c.dial_code === prefixSigner) || null}
                        onChange={(event, newValue) => {
                          setPrefixSigner(newValue?.dial_code || "+39");
                        }}
                        getOptionLabel={(option) => `${option.emoji} ${option.dial_code}`}
                        filterOptions={(options, { inputValue }) => {
                          const searchTerm = inputValue.toLowerCase();
                          return options.filter(
                            (option) =>
                              option.name.toLowerCase().includes(searchTerm) ||
                              option.dial_code.includes(searchTerm) ||
                              option.code.toLowerCase().includes(searchTerm)
                          );
                        }}
                        renderInput={(params) => (
                          <TextField {...params} placeholder="Cerca..." />
                        )}
                        renderOption={(props, option) => (
                          <li {...props}>
                            {option.emoji} {option.dial_code} - {option.name}
                          </li>
                        )}
                        isOptionEqualToValue={(option, value) => option.code === value.code}
                      />
                    </Grid>
                    <Grid item xs={6} sm={9}>
                      <TextField
                        fullWidth
                        name="signer_phone_number"
                        defaultValue={changeSigner.phone_number}
                        onChange={(e) =>
                          setDataUpdate({
                            ...dataUpdate,
                            phone_number: e.target.value,
                          })
                        }
                        placeholder="Phone number"
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {/* Footer buttons */}
              <Grid
                item
                xs={12}
                sx={{
                  mt: 4,
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  onClick={subimtDataChange(changeSigner)}
                  disabled={disableButtonUpdateDataSigner}
                  variant="outlined"
                  className="button-bg-purple"
                  sx={{
                    width: { xs: "100% !important", sm: "160px !important" },
                    border: "none !important",
                  }}
                >
                  <Typography
                    className="color-light"
                    sx={{
                      textTransform: "initial",
                      fontSize: { xs: "14px", sm: "18px" },
                      fontWeight: 500,
                    }}
                  >
                    Aggiorna
                  </Typography>
                </Button>
              </Grid>
            </Grid>
          </Modal>
        </div>
      </>
    );
  } else {
    const lista = paperwork.map((numero, index) => {
      const date = new Date(numero.created_at);
      const timestamp = date.getTime();
      const date2 = new Date(timestamp);
      const dateLocale = date2.toLocaleString("it-IT");

      return (
        <>
          <TableRow key={index} style={{ height: "50px" }}>
            <TableCell
              sx={{
                padding: "8px",
                whiteSpace: { xs: "nowrap", sm: "normal" },
              }}
              className="color-blue-dark"
            >
              <Typography className="text-table"> {numero.id}</Typography>
            </TableCell>
            <TableCell
              className="color-blue-dark"
              sx={{
                padding: "8px",
                whiteSpace: { xs: "nowrap", sm: "normal" },
              }}
            >
              <Typography className="text-table">
                {" "}
                {numero.paperwork_name}
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                padding: "8px",
                whiteSpace: { xs: "nowrap", sm: "normal" },
              }}
              className="color-blue-dark"
            >
              <Typography className="text-table"> {dateLocale}</Typography>
            </TableCell>
            <TableCell
              sx={{
                padding: "8px",
                whiteSpace: { xs: "nowrap", sm: "normal" },
              }}
              className="color-blue-dark"
            >
              <Typography className="text-table">{departmentName}</Typography>
            </TableCell>
            <TableCell
              sx={{
                padding: "8px",
                whiteSpace: { xs: "nowrap", sm: "normal" },
              }}
              className="color-blue-dark"
            >
              <Typography className="text-table">
                {numero.signature_level === "advanced" ? "Firma Elettronica Rafforzata" : numero.signature_level === "electronic" ? "Firma Elettronica Semplice" : "-"}
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                padding: "8px",
                width: { sm: "150px", xs: "auto" },
                textAlign: "start",
                whiteSpace: { xs: "nowrap", sm: "normal" },
              }}
              className="color-blue-dark"
            >
              <Typography className="text-table">In corso</Typography>
            </TableCell>
          </TableRow>
        </>
      );
    });

    return (
      <>
        <div style={{ marginTop: "150px", marginBottom: "50px" }}>
          <Grid container style={{ display: "flex", justifyContent: "center" }}>
            {/* Operation details */}
            <Grid item xs={11} md={10}>
              <Typography
                className="color-blue-dark"
                style={{
                  fontSize: "22px",
                  fontWeight: 600,
                  marginBottom: "30px",
                }}
              >
                Dettagli signing
              </Typography>

              <TableContainer
                component={Paper}
                sx={{ maxWidth: "100%", boxShadow: "none" }}
              >
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          ID
                        </Typography>
                      </TableCell>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          Nome operazione
                        </Typography>
                      </TableCell>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold ">
                          Data creazione
                        </Typography>
                      </TableCell>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          Team
                        </Typography>
                      </TableCell>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          Livello firma
                        </Typography>
                      </TableCell>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          Stato
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>{lista}</TableBody>
                </Table>
              </TableContainer>
            </Grid>

            {/* Signers */}
            <Grid item xs={11} md={10} style={{ marginTop: "30px" }}>
              <Typography
                className="color-blue-dark"
                style={{
                  fontSize: "22px",
                  fontWeight: 600,
                  marginBottom: "30px",
                }}
              >
                Firmatari
              </Typography>

              <TableContainer
                component={Paper}
                sx={{ maxWidth: "100%", boxShadow: "none" }}
              >
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          ID
                        </Typography>
                      </TableCell>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          Nome e Cognome
                        </Typography>
                      </TableCell>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          fontSize: "0.9rem",
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          Email
                        </Typography>
                      </TableCell>
                      {paperwork[0]?.signature_level !== "electronic" && (
                        <TableCell
                          className="color-blue-dark"
                          sx={{
                            fontSize: "0.9rem",
                            padding: "8px",
                            whiteSpace: { xs: "nowrap", sm: "normal" },
                          }}
                        >
                          <Typography className="title-column-table text-bold">
                            Numero di telefono
                          </Typography>
                        </TableCell>
                      )}
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          fontSize: "0.9rem",
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          Stato
                        </Typography>
                      </TableCell>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          fontSize: "0.9rem",
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          Azioni
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>{signersList}</TableBody>
                </Table>
              </TableContainer>
            </Grid>

            {readers.length > 0 && (
              <Grid item xs={11} md={10} style={{ marginTop: "30px" }}>
                <Typography
                  className="color-blue-dark"
                  style={{
                    fontSize: "22px",
                    fontWeight: 600,
                    marginBottom: "30px",
                  }}
                >
                  Lettori
                </Typography>

                <TableContainer
                  component={Paper}
                  sx={{ maxWidth: "100%", boxShadow: "none" }}
                >
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          className="color-blue-dark"
                          sx={{
                            padding: "8px",
                            whiteSpace: { xs: "nowrap", sm: "normal" },
                          }}
                        >
                          <Typography className="title-column-table">
                            ID
                          </Typography>
                        </TableCell>
                        <TableCell
                          className="color-blue-dark"
                          sx={{
                            padding: "8px",
                            whiteSpace: { xs: "nowrap", sm: "normal" },
                          }}
                        >
                          <Typography className="title-column-table text-bold">
                            Nome e Cognome
                          </Typography>
                        </TableCell>
                        <TableCell
                          className="color-blue-dark"
                          sx={{
                            padding: "8px",
                            whiteSpace: { xs: "nowrap", sm: "normal" },
                          }}
                        >
                          <Typography className="title-column-table text-bold">
                            Email
                          </Typography>
                        </TableCell>
                        {/* <TableCell
                          className="color-blue-dark"
                          sx={{ padding: "8px" }}
                        >
                          <Typography className="title-column-table text-bold">
                            Numero di telefono
                          </Typography>
                        </TableCell> */}
                        <TableCell
                          className="color-blue-dark"
                          sx={{
                            padding: "8px",
                            whiteSpace: { xs: "nowrap", sm: "normal" },
                          }}
                        >
                          <Typography className="title-column-table text-bold">
                            Stato
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>{readersList}</TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}

            {/* Files to be signed */}
            <Grid
              item
              xs={11}
              md={10}
              style={{ marginTop: "30px", marginBottom: "80px" }}
            >
              <Typography
                className="color-blue-dark"
                style={{
                  fontSize: "22px",
                  fontWeight: 600,
                  marginBottom: "30px",
                }}
              >
                Documenti
              </Typography>

              <TableContainer
                component={Paper}
                sx={{ maxWidth: "100%", boxShadow: "none" }}
              >
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          Titolo
                        </Typography>
                      </TableCell>
                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          File
                        </Typography>
                      </TableCell>

                      <TableCell
                        className="color-blue-dark"
                        sx={{
                          padding: "8px",
                          whiteSpace: { xs: "nowrap", sm: "normal" },
                        }}
                      >
                        <Typography className="title-column-table text-bold">
                          Stato
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>{filesNotSignedList}</TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>

          <Grid
            container
            className="bg-blue-dark"
            style={{
              position: "fixed",
              bottom: 0,
              left: 0,
              width: "100%",
              padding: "15px 0px",
              display: "flex",
              justifyContent: {
                xs: "space-around",
                sm: "center",
              },
              alignItems: "center",
            }}
          >
            <Grid
              container
              sx={{
                paddingLeft: { xs: "20px", sm: "80px" },
                paddingRight: { xs: "20px", sm: "80px" },
              }}
            >
              <Grid item xs={6} md={6}></Grid>

              <Grid
                item
                xs={6}
                md={6}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  variant="contained"
                  className="button-bg-purple"
                  onClick={handleShowModalRestart}
                >
                  <Typography
                    className="color-light"
                    sx={{
                      textTransform: "initial",
                      fontSize: { xs: "16px", sm: "18px" },
                      fontWeight: 500,
                    }}
                  >
                    {"Riavvia"}
                  </Typography>
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </div>

        <Modal
          open={showChangeFirmatario}
          onClose={handleGoBackChangeFirmatario}
        >
          <Grid
            container
            item
            xs={11}
            md={5}
            sx={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "#fff",
              maxHeight: "90vh",
              overflowY: "auto",
              boxShadow: 24,
              p: 3,
            }}
          >
            {/* Header */}
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #c6c6c6",
                pb: 2,
                mb: 2,
              }}
            >
              <div style={{ display: "flex" }}>
                <div className="icon-modal-edit" />
                <Typography
                  id="change-signer-title"
                  variant="h6"
                  className="color-blue-dark"
                >
                  Modifica dati firmatario
                </Typography>
              </div>
              <div
                onClick={handleGoBackChangeFirmatario}
                className="icon-modal-close"
              />
            </Grid>

            <Typography className="color-blue-dark" sx={{ mb: 2 }}>
              In caso di operazioni con più di 20 firmatari, contattare il team
              tecnico prima di avviare la firma.
            </Typography>

            <Grid item xs={12} sx={{ mb: 2 }}>
              <Typography
                style={{ fontSize: "14px" }}
                className="color-dark-blue"
              >
                Nome
              </Typography>
              <TextField
                fullWidth
                size="small"
                name="signer_firstname"
                placeholder="First name"
                defaultValue={changeSigner.firstname}
                error={errors.includes("firstname")}
                onChange={(e) =>
                  setDataUpdate({
                    ...dataUpdate,
                    firstname: e.target.value,
                  })
                }
              />
            </Grid>

            <Grid item xs={12} sx={{ mb: 2 }}>
              <Typography
                style={{ fontSize: "14px" }}
                className="color-dark-blue"
              >
                Cognome
              </Typography>
              <TextField
                fullWidth
                size="small"
                name="signer_lastname"
                error={errors.includes("lastname")}
                placeholder="Last name"
                defaultValue={changeSigner.lastname}
                onChange={(e) =>
                  setDataUpdate({
                    ...dataUpdate,
                    lastname: e.target.value,
                  })
                }
              />
            </Grid>

            <Grid item xs={12} sx={{ mb: 2 }}>
              <Typography
                style={{ fontSize: "14px" }}
                className="color-dark-blue"
              >
                Email
              </Typography>
              <TextField
                fullWidth
                size="small"
                type="email"
                name="signer_email"
                placeholder="name@example.com"
                error={errors.includes("email")}
                defaultValue={changeSigner.email}
                onChange={(e) =>
                  setDataUpdate({
                    ...dataUpdate,
                    email: e.target.value,
                  })
                }
              />
              <Typography className={colorMessage}>
                {messageEmailValidation}
              </Typography>
            </Grid>

            {paperwork[0]?.signature_level !== "electronic" && (
              <Grid item xs={12} sx={{ mb: 2 }}>
                <Typography
                  style={{ fontSize: "14px" }}
                  className="color-dark-blue"
                >
                  Numero di telefono
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6} sm={3}>
                    <Autocomplete
                      options={mobilePrefixes}
                      value={mobilePrefixes.find(c => c.dial_code === prefixSigner) || null}
                      onChange={(event, newValue) => {
                        setPrefixSigner(newValue?.dial_code || "+39");
                      }}
                      getOptionLabel={(option) => `${option.emoji} ${option.dial_code}`}
                      filterOptions={(options, { inputValue }) => {
                        const searchTerm = inputValue.toLowerCase();
                        return options.filter(
                          (option) =>
                            option.name.toLowerCase().includes(searchTerm) ||
                            option.dial_code.includes(searchTerm) ||
                            option.code.toLowerCase().includes(searchTerm)
                        );
                      }}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Cerca..." />
                      )}
                      renderOption={(props, option) => (
                        <li {...props}>
                          {option.emoji} {option.dial_code} - {option.name}
                        </li>
                      )}
                      isOptionEqualToValue={(option, value) => option.code === value.code}
                    />
                  </Grid>
                  <Grid item xs={6} sm={9}>
                    <TextField
                      fullWidth
                      name="signer_phone_number"
                      placeholder="Phone number"
                      error={errors.includes("phone_number")}
                      defaultValue={changeSigner.phone_number}
                      onChange={(e) =>
                        setDataUpdate({
                          ...dataUpdate,
                          phone_number: e.target.value,
                        })
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            )}

            <TextField
              type="text"
              hidden
              name="id_signer"
              defaultValue={changeSigner.id_signer}
              onChange={(e) =>
                setDataUpdate({
                  ...dataUpdate,
                  id_signer: e.target.value,
                })
              }
            />

            {/* Footer */}
            <Grid
              item
              xs={12}
              sx={{
                mt: 4,
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
              }}
            >
              <Button
                onClick={subimtDataChange(changeSigner)}
                disabled={disableButtonUpdateDataSigner}
                variant="outlined"
                className="button-bg-purple"
                sx={{
                  width: { xs: "100% !important", sm: "160px !important" },
                  border: "none !important",
                }}
              >
                <Typography
                  className="color-light"
                  sx={{
                    textTransform: "initial",
                    fontSize: { xs: "14px", sm: "18px" },
                    fontWeight: 500,
                  }}
                >
                  Aggiorna
                </Typography>
              </Button>
            </Grid>
          </Grid>
        </Modal>

        <Modal open={showUpdate} onClose={handleCloseShowUpdate}>
          <ModalConferma
            title="Conferma modifica dati firmatario"
            descriptionOne="copy"
            descriptionTwo=""
            copyButton="Sì, modifica"
            onClose={handleCloseShowUpdate}
            confirm={subimtDataChange(changeSigner)}
          />
        </Modal>

        <Modal open={showReminder} onClose={handleCloseShowReminder}>
          <ModalConferma
            title="Promemoria"
            descriptionOne="Con questa azione invierai un promemoria via mail al firmatario. Vuoi procedere?"
            descriptionTwo=""
            copyButton="Sì, invia"
            onClose={handleCloseShowReminder}
            confirm={subimtReminder(numeroSignReminder)}
          />
        </Modal>

        {/* modal success edit  */}
        <Modal open={showUpdateSuccess} onClose={handleGoBackUpdateSuccess}>
          <ModalSuccess
            title="Modifica effettuata con successo"
            descriptionOne="Dati del firmatario aggiornati."
            descriptionTwo="copy"
            copyButton="Chiudi"
            confirm={handleGoBackUpdateSuccess}
            onClose={handleGoBackUpdateSuccess}
          />
        </Modal>

        {/* modal remider  */}
        <Modal open={showReminderSuccess} onClose={handleGoBackReminderSuccess}>
          <ModalSuccess
            title="Promemoria inviato con successo"
            descriptionOne="Il firmatario ha ricevuto una email di sollecito."
            descriptionTwo=""
            copyButton="Chiudi"
            confirm={handleGoBackReminderSuccess}
            onClose={handleGoBackReminderSuccess}
          />
        </Modal>

        {/* modal reset  */}
        <Modal open={showRestart} onClose={handleGoBackRestart}>
          <ModalReset
            title="Riavvia"
            descriptionOne={
              <>
                Attenzione! L'operazione verrà cancellata e ne verrà creata un'altra uguale
                vergine. I firmatari che avevano già firmato dovranno firmare nuovamente
                e ulteriori costi saranno caricati su LEXIA. <br />
                Sei sicuro di procedere?
                <br />
                <br />
                <strong>Deleting ID:</strong> {paperworkId}
              </>
            }
            descriptionTwo=""
            descriptionThree=""
            copyButton="Sì, riavvia"
            onClose={handleGoBackRestart}
            confirm={handleRestart(paperworkId)}
          />
        </Modal>

        {/* modal success restart  */}
        <Modal open={showRestartSuccess} onClose={handleGoBackRestartSuccess}>
          <ModalSuccess
            title="Signing riavviato con successo!"
            descriptionOne={`Puoi seguire l'operazione nella schermata "Signing in corso"`}
            descriptionTwo=""
            copyButton="Chiudi"
            confirm={handleGoBackRestartSuccess}
            onClose={handleGoBackRestartSuccess}
          />
        </Modal>

        {isLoading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 2000,
            }}
          >
            <CircularProgress style={{ color: "#1b2838" }} />
          </div>
        )}

        {showRotateModal && (
          <Modal
            open={showRotateModal}
            onClose={handleCloseRotateModal}
          >
            <div>
              <ModalHelper
                onClose={handleCloseRotateModal}
                modalObjectInfo={{
                  infoTitle: "Visualizzazione",
                  description:
                    "A seconda del tuo smartphone e delle tue preferenze, puoi ruotare lo schermo per una visione orizzontale.",
                  descriptionBis: "",
                }}
              />
            </div>
          </Modal>
        )}
      </>
    );
  }
};
export default Paperwork;

/**
 *
 Era nella modale
<!--<Button variant="primary" className={["d-bgcolor","d-bordercolor"]} onClick={subimtReminder(changeSigner)}>
    Resend invitation
</Button>--> **/
